import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "slick-carousel/slick/slick.scss";
import "./scss/index.scss"; // import classNames from "classnames";

import { RichText } from "prismic-reactjs";
import React, { useRef, useState } from "react";
import Slider from "react-slick";
import { ResizeImage } from "@temp/@prismic/components/ResizeImage"; // import { useIntl } from "react-intl";

import { linkResolver } from "../../prismic-config";
export function InstagramItemsStatic(_ref) {
  var itemsList = _ref.items;
  // const intl = useIntl();
  // const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  var slider = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      startPos = _useState2[0],
      setStartPos = _useState2[1];

  var touchStart = function touchStart(e) {
    setStartPos(e.nativeEvent.touches[0].clientX);
  };

  var touchEnd = function touchEnd(e) {
    var endPos = e.nativeEvent.changedTouches[0].clientX;
    var delta = startPos - endPos;
    var minDeltaValue = 25;

    if (Math.abs(delta) > minDeltaValue && delta > 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      slider.current.slickNext();
    }

    if (Math.abs(delta) > minDeltaValue && delta < 0) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      slider.current.slickPrev();
    }
  };

  var sliderSettings = {
    arrows: true,
    // autoplay: true,
    autoplaySpeed: 4000,
    // beforeChange: (prev = undefined, el: number) => {
    //   setActiveSlideIndex(Math.floor(el / sliderSettings.slidesToShow));
    // },
    dots: false,
    infinite: false,
    responsive: [// {
    //   breakpoint: 1279,
    //   settings: {
    //     slidesToShow: 3,
    //   },
    // },
    {
      breakpoint: 767,
      settings: {
        infinite: true,
        // slidesToShow: 2,
        swipe: false
      }
    }],
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 600,
    variableWidth: true
  }; // const slidesCount: number = Math.ceil(
  //   itemsList.length / sliderSettings.slidesToShow
  // );
  // const slides = new Array(slidesCount).fill("").map((z, i) => {
  //   if (i < 9) {
  //     return `0${i + 1}`;
  //   }
  //   return i + 1;
  // });
  // function handleClick(index: number): void {
  //   slider.current.slickGoTo(index * sliderSettings.slidesToShow);
  //   if (index !== activeSlideIndex) {
  //     setActiveSlideIndex(-1);
  //   }
  // }

  return React.createElement("div", {
    className: "instagram-items-static__wr container"
  }, React.createElement("div", {
    className: "instagram-items-static",
    onTouchStart: function onTouchStart(e) {
      return touchStart(e);
    },
    onTouchEnd: function onTouchEnd(e) {
      return touchEnd(e);
    }
  }, React.createElement(Slider, _extends({}, sliderSettings, {
    className: "instagram-items-static__slider",
    ref: slider
  }), itemsList === null || itemsList === void 0 ? void 0 : itemsList.map(function (_ref2, i) {
    var image = _ref2.image,
        post_title = _ref2.post_title,
        post_user_name = _ref2.post_user_name,
        user_avatar = _ref2.user_avatar,
        instagram_link = _ref2.instagram_link;
    return React.createElement("div", {
      className: "instagram-items-static__item",
      key: i
    }, React.createElement("div", {
      className: "instagram-items-static__item-image"
    }, React.createElement(ResizeImage, image)), React.createElement("div", {
      className: "instagram-items-static__item-info"
    }, user_avatar && React.createElement("div", {
      className: "instagram-items-static__item-avatar-wr"
    }, React.createElement("img", {
      className: "instagram-items-static__item-avatar",
      src: user_avatar.url,
      alt: "instagram avatar"
    })), React.createElement("div", {
      className: "instagram-items-static__item-text"
    }, post_title && React.createElement(RichText, {
      render: post_title
    }), React.createElement("a", {
      href: linkResolver(instagram_link),
      target: "_blank",
      rel: "noreferrer",
      className: "instagram-items-static__item-link"
    }, typeof post_user_name === "string" ? React.createElement("p", null, post_user_name) : React.createElement(RichText, {
      render: post_user_name
    })))));
  }))));
}